// Normaliza el bloque de tarjetas (KPI + topProductos)
export const normalizeTarjetasData = (raw) => {
  const r =
    raw?.tarjetaDashboardDtoHelperResponse ??
    raw?.tarjetasDashboardDto ??
    raw ?? {};

  const pick = (a, b) => (a !== undefined ? a : b);

  const ventasDelMes = Number(pick(r.ventasDelMes, r.VentasDelMes) ?? 0);
  const comisionVentas = Number(pick(r.comisionVentas, r.ComisionVentas) ?? 0);
  const ticketPromedio = Number(pick(r.ticketPromedio, r.TicketPromedio) ?? 0);

  const unidadesVendidas = Number(pick(r.unidadesVendidas, r.UnidadesVendidas) ?? 0);

  const variacionMensualVentas = Number(pick(r.variacionMensualVentas, r.VariacionMensualVentas) ?? 0);
  const variacionMensualUnidades = Number(pick(r.variacionMensualUnidades, r.VariacionMensualUnidades) ?? 0);
  const variacionAnualVentas = Number(pick(r.variacionAnualVentas, r.VariacionAnualVentas) ?? 0);
  const variacionAnualUnidades = Number(pick(r.variacionAnualUnidades, r.VariacionAnualUnidades) ?? 0);

  const topRaw = r.topProductoDtoResponse ?? r.topProductos ?? r.TopProductoDtoResponse ?? [];
  const topProductos = Array.isArray(topRaw)
    ? topRaw.map(p => ({
      codigoProducto: p.codigoProducto ?? p.CodigoProducto ?? '',
      nombreProducto: p.nombreProducto ?? p.NombreProducto ?? '',
      unidadesVendidas: Number(p.unidadesVendidas ?? p.UnidadesVendidas ?? 0),
      montoVentas: Number(p.montoVentas ?? p.MontoVentas ?? 0),
      idPublicacion: p.idPublicacion ?? p.IdPublicacion ?? null,
      idSeller: p.idSeller ?? p.IdSeller ?? null,
    }))
    : [];

  return {
    ventasDelMes,
    comisionVentas,
    ticketPromedio,
    unidadesVendidas,
    variacionMensualVentas,
    variacionMensualUnidades,
    variacionAnualVentas,
    variacionAnualUnidades,
    topProductos,
  };
};

// Pie de estados
export const buildPieData = (resumenEstadosOrden) => {
  const r = resumenEstadosOrden || { total: 0, facturadas: 0, pendienteFacturar: 0, anuladas: 0 };
  return {
    labels: ['Facturadas', 'Pendiente facturar', 'Anuladas'],
    datasets: [{
      label: 'Órdenes por estado',
      data: [
        Number(r.facturadas ?? r.Facturadas ?? 0),
        Number(r.pendienteFacturar ?? r.PendienteFacturar ?? 0),
        Number(r.anuladas ?? r.Anuladas ?? 0),
      ],
      backgroundColor: [
        'rgba(54, 162, 235, 0.5)',
        'rgba(255, 206, 86, 0.5)',
        'rgba(255, 99, 132, 0.5)',
      ],
      borderColor: [
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(255, 99, 132, 1)',
      ],
      borderWidth: 1,
    }],
  };
};

export const getTotalOrdenes = (r) => Number(r?.total ?? r?.Total ?? 0);

export const hasChartData = (dataset) => {
  const values = dataset?.datasets?.[0]?.data ?? [];
  return values.some(v => Number(v) > 0);
};

// Bar de categorías
export const buildCategoriasBarData = (cats = [], modo = 'monto') => {
  const labels = cats.map(c => c.nombreCategoria);
  const data = cats.map(c => (modo === 'monto' ? Number(c.montoVentas || 0) : Number(c.unidadesVendidas || 0)));
  const isMonto = modo === 'monto';

  return {
    labels,
    datasets: [{
      label: isMonto ? 'Monto Ventas ($)' : 'Unidades Vendidas',
      data,
      backgroundColor: isMonto ? 'rgba(54, 162, 235, 0.5)' : 'rgba(255, 206, 86, 0.5)',
      borderColor: isMonto ? 'rgba(54, 162, 235, 1)' : 'rgba(255, 206, 86, 1)',
      borderWidth: 1,
    }],
  };
};

const currencyFmt = new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 0 });
export const getBarOptions = (modo = 'monto') => {
  const isMonto = modo === 'monto';
  return {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: { legend: { display: false }, title: { display: false }, tooltip: { enabled: true } },
    scales: {
      y: { ticks: { autoSkip: false } },
      x: {
        ticks: {
          precision: 0,
          callback: (v) => (isMonto ? currencyFmt.format(v) : v),
        },
      },
    },
  };
};
